// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__322Jh","containerForm":"styles_containerForm__3yv8P"};